import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Transition as _Transition, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "resetPasswordValidate errorMessage"
}
const _hoisted_2 = {
  key: 1,
  class: "resetPasswordValidate errorMessage"
}
const _hoisted_3 = {
  key: 2,
  class: "resetPasswordValidate errorMessage"
}
const _hoisted_4 = {
  key: 3,
  class: "resetPasswordValidate-loading"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "password-input" }
const _hoisted_7 = ["disabled", "placeholder"]
const _hoisted_8 = ["disabled", "placeholder"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "status" }

import { ref, computed, onMounted, nextTick, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useStore } from '@/store';
import Loader from '@pf/vue3/Loader.vue';
import Bubble from '../components/Bubble.vue';
import axios, { AxiosResponse } from 'axios';
import PasswordRequirementsChecker, { WachtwoordRequirements } from "shared/vue/PasswordRequirementsChecker.vue";

interface ValidateResetPasswordRequest
{
    Token: string;
}

interface ValidateResetPasswordTokenResponse
{
    Email: string,
    WachtwoordLengte: number,
    IsHoofdletterVerplicht: boolean,
    IsCijferVerplicht: boolean,
    IsSpeciaalTekenVerplicht: boolean,
}


interface SavePasswordRequest
{
    Token: string;
    Password: string;
}



export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordValidate',
  setup(__props) {

const i18n = useI18n();
const { t } = i18n;
const route = useRoute();
const store = useStore();

const passwordInput = ref<HTMLInputElement | null>(null);
const passwordconfirmInput = ref<HTMLInputElement | null>(null);
const passwordChecker = ref<Element>();

const passwordRequirementsVisible = ref<boolean>(false);

const passwordRequirements = ref<WachtwoordRequirements>({
  forbiddenUserInfo: [],
  includeCapital: false,
  includeNumber: false,
  includeSymbol: false,
  minimumLength: 8
});

const passwordRequirementsTopOffset = computed(() => {
    if (!passwordRequirements.value)
        return "";

    let offset = -45; // Standaard offset + tekst "wachtwoord eisen.
    offset -= 20; // Lengte requirement offset.
    if (passwordRequirements.value.includeCapital)
        offset -= 20;

    if (passwordRequirements.value.includeNumber)
        offset -= 20;

    if (passwordRequirements.value.includeSymbol)
        offset -= 20;


    return offset + "px";
});

const token = ref<string | null>(null);
const validating = ref(true);
const tokenError = ref(false);
const unknownError = ref(false);
const attemptedReset = ref(false);
const successfulReset = ref(false);
const password = ref('',);
const passwordConfirm = ref('',);
const message = ref<string | null>(null);


const username = computed<string>(() =>
{
    return store.username.value;
});


const passwordValid = computed<boolean>(() =>
{
    return !!password.value;
});

const passwordConfirmValid = computed<boolean>(() =>
{
    return passwordValid.value && passwordConfirm.value === password.value;
});
    
onMounted(() =>
{
    document.title = t('title');
    watch(i18n.locale, () => { document.title = t('title'); });

    if (!!route.query.token)
        token.value = route.query.token.toString();

    validateToken();
});


async function validateToken()
{
    const response = await axios.post<ValidateResetPasswordRequest, AxiosResponse<ValidateResetPasswordTokenResponse>>('/v2/resetpassword/validate', 
        {
            Token: token.value
        } as ValidateResetPasswordRequest);

    switch (response.status)
    {
        case 200:
            store.username.value = response.data.Email;

            passwordRequirements.value.includeCapital = response.data.IsHoofdletterVerplicht;
            passwordRequirements.value.includeNumber = response.data.IsCijferVerplicht;
            passwordRequirements.value.includeSymbol = response.data.IsSpeciaalTekenVerplicht;
            passwordRequirements.value.minimumLength = response.data.WachtwoordLengte;

            break;

        case 401:
            tokenError.value = true;
            break;

        default:
            unknownError.value = true;
            break;
    }

    validating.value = false;

    nextTick(() =>
    {
        passwordInput.value?.focus();
    });
}
        
        
async function resetPassword()
{
    attemptedReset.value = true;

    if (!passwordValid.value)
    {
        showMessage(t('error.nopassword'));
        nextTick(() =>
        {
            passwordInput.value?.focus();
        });

        return;
    }

    if (!passwordConfirmValid.value)
    {
        showMessage(t('error.confirmpassword'));
        nextTick(() =>
        {
            passwordconfirmInput.value?.focus();
        });

        return;
    }

    clearMessage();
    validating.value = true;
    try
    {
        const response = await axios.post('/v2/resetpassword/save', 
            {
                Token: token.value,
                Password: password.value
            } as SavePasswordRequest);

        switch (response.status)
        {
            case 200:
                // De huidige pagina switchen in plaats van weg navigeren, anders kun je te makkelijk terug                    
                successfulReset.value = true;
                break;

            case 406:
                showMessage(t('error.notstrongenough'));
                nextTick(() =>
                {
                    passwordInput.value?.focus();
                });

                break;

            default:
                showMessage(t('error.unknown'));
                break;
        }
    }
    finally
    {
        validating.value = false;
    }
}


function clearMessage()
{
    message.value = null;
}


function showMessage(value: string)
{
    message.value = value;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(Bubble, null, {
    default: _withCtx(() => [
      (successfulReset.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(_unref(t)('success')) + " ", 1),
            _createVNode(_component_router_link, {
              to: { name: 'login' },
              class: "continue"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('loginLink')), 1)
              ]),
              _: 1
            })
          ]))
        : (tokenError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(_unref(t)('error.invalidToken')) + " ", 1),
              _createVNode(_component_router_link, {
                to: { name: 'resetpassword' },
                class: "continue"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('error.resetPasswordLink')), 1)
                ]),
                _: 1
              })
            ]))
          : (unknownError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)('error.unknown')), 1))
            : (validating.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(Loader, { style: 'white' })
                ]))
              : (_openBlock(), _createElementBlock("form", {
                  key: 4,
                  class: "resetPasswordValidate",
                  onSubmit: _withModifiers(resetPassword, ["prevent"])
                }, [
                  _createElementVNode("input", {
                    type: "text",
                    id: "username",
                    name: "username",
                    value: username.value,
                    autocomplete: "username",
                    style: {"display":"none"}
                  }, null, 8, _hoisted_5),
                  _createElementVNode("div", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass(["form-control", { error: attemptedReset.value && !passwordValid.value }]),
                      id: "password",
                      ref_key: "passwordInput",
                      ref: passwordInput,
                      disabled: validating.value,
                      placeholder: _unref(t)('placeholders.password'),
                      type: "password",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                      autofocus: "",
                      autocomplete: "new-password",
                      onFocus: _cache[1] || (_cache[1] = ($event: any) => (passwordRequirementsVisible.value = true)),
                      onBlur: _cache[2] || (_cache[2] = ($event: any) => (passwordRequirementsVisible.value = false))
                    }, null, 42, _hoisted_7), [
                      [_vModelText, password.value]
                    ]),
                    _createVNode(_Transition, null, {
                      default: _withCtx(() => [
                        (passwordRequirementsVisible.value)
                          ? (_openBlock(), _createBlock(PasswordRequirementsChecker, {
                              key: 0,
                              ref_key: "passwordChecker",
                              ref: passwordChecker,
                              newPassword: password.value,
                              newPasswordConfirm: passwordConfirm.value,
                              "wachtwoord-requirements": passwordRequirements.value,
                              checkNewPaswswordConfirmed: false,
                              class: "passwordRequirements",
                              style: _normalizeStyle({ 'top': passwordRequirementsTopOffset.value })
                            }, null, 8, ["newPassword", "newPasswordConfirm", "wachtwoord-requirements", "style"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["form-control", { error: attemptedReset.value && !passwordConfirmValid.value }]),
                    id: "passwordConfirm",
                    ref_key: "passwordconfirmInput",
                    ref: passwordconfirmInput,
                    disabled: validating.value,
                    placeholder: _unref(t)('placeholders.passwordConfirm'),
                    type: "password",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((passwordConfirm).value = $event)),
                    autocomplete: "new-password"
                  }, null, 10, _hoisted_8), [
                    [_vModelText, passwordConfirm.value]
                  ]),
                  _createElementVNode("input", {
                    type: "submit",
                    id: "reset",
                    class: "btn",
                    value: _unref(t)('submit')
                  }, null, 8, _hoisted_9),
                  _createElementVNode("div", _hoisted_10, [
                    (validating.value && message.value === null)
                      ? (_openBlock(), _createBlock(Loader, {
                          key: 0,
                          style: 'white'
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(message.value), 1)
                  ])
                ], 32))
    ]),
    _: 1
  }))
}
}

})